var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapRegions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 1100,
    viewBox: "0 0 350 500",
    style: {
      margin: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_79",
    x: 190.831,
    y: 368.533,
    width: 35.496,
    height: 24.911,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-2",
    x: 212.831,
    y: 336.533,
    width: 39.616,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-3",
    x: 184.831,
    y: 298.533,
    width: 54.492,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-4",
    x: 176.831,
    y: 256.533,
    width: 58.282,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-5",
    x: 166.831,
    y: 215.033,
    width: 52.059,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-6",
    x: 121.831,
    y: 138.033,
    width: 52.059,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-7",
    x: 79.513,
    y: 324.053,
    width: 41.377,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-8",
    x: 79.831,
    y: 381.512,
    width: 52.059,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-9",
    x: 184.831,
    y: 385.772,
    width: 52.059,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-10",
    x: 104.438,
    y: 313.512,
    width: 56.419,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-11",
    x: 103.412,
    y: 227.772,
    width: 55.445,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_79-12",
    x: 0,
    y: 196.012,
    width: 62.857,
    height: 26.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PACE-REGIONS-SVG-MAP",
    transform: "translate(-730.673 -582.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Free_uk_regions_map_vector_SVG",
    "data-name": "Free uk regions map vector_SVG",
    transform: "translate(620.5 545.6)"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=London"
  }, /*#__PURE__*/React.createElement("path", {
    id: "London",
    d: "M323.3,416.3v1.3h-.9a6.035,6.035,0,0,1-.8.8v-.9l-1.3,1.6L320,418l-2.8-.7s-.1.6-.2.6-1.1.2-1.1.2l.3.3,1.2-.1.2-.4,1.7.6.4.7-.5.4.7.8-.1.6H319v.5l-.4-.1-.4.4v1.7l-.5-.5.1,1.8-.5.3H317l-.8,2.1h-1.3l-1.2-1.6v-.5l-.8-.5-.4.9h-.9l-.4.8-.9.5-.8-.5V425l-.4-.2v-.6l-.6.1-.8.5.1-.7.4-.5-.4-.4-.5.1v-.5l-.8.1v.5l-.6.5-.1.6-.5.5-.5-.4.2-.4.1-.3.6-.5v-.5l.4-.4-.5-.4h-.5l.1-.5-.4-.4h-.9l.1-.9-.5.1-.3-.5-.5.1-.4-.4.1-.9h-.5l-.9-.7.4-1.2.5-.5v-1.7h.5v-1.3l-.6-1.2.5-.7v-.7l.8.9h1.4l-.1.5h.8l.4-.5.5.1.4-.5,2.2.1v-.5h.9l.7-.4h.5l.4-.4v-.5H313l.7.5.9-.1.4.4h.4v.9l-.4.4,1.3.8-.5.5.4.4.6-.1.4.5.8-.1.8-.5,2.6.1,1.1,1.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=Anglia"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Anglia",
    d: "M364.8,382.7l-.6.7.1,1.2-1.4,3.3-1.1.9-1.4,4.5-.1,1-1.1,2.8-.5.8-2.3.7-1.4,1.5-.2.7-1,.1-1-4.8-.8.4-.6.9.9.6.9,3.3-.5,1.2-1.5.8-.7-2.7-2.3-1h-.3l.3.2-.1.3,1.8,1.1.4,1.3-1.7-.1-1.3-.8-1.4.3h-1.3l.5,1,4.8.2.6.6-.8,1.1-1.2.6.4,1.4,1.6-.6v.7l-1.2,1.1-1.4.8-.4.4-2.6.7-1.1-1.5.4-1.1-.9.2-.7-.9-.9-.7-.8,1.8,1.3.9-1.2.7-.4-.8-1.2-.1-1,.6,1.1.6-2.3.9h-3.3l.2,1,.9,1.2h1.3l4-2.1.3,3.4-.7,1.1-2.8.4.5,1.1,2.6-.2-2.8,2.3v-1l.2-.6-3.1-.1.2.6,1.5.4.2.9-1.3.5-1.8-.6-1.9-.2-1.6-.7.9,1.2-.1.8-.9-.3-.2-1.4-.9.1.6,1H327l-2.2,1.8-1.8-.4-.5-.9-2-.2-.1-.5,1.3-1.6v.9l.8-.8h.9v-1.3l-1-1-1.1-1.9-2.6-.1-.8.5-.8.1-.4-.5-.6.1-.4-.4.5-.5-1.3-.8.4-.4v-.9h-.4l-.4-.4-.9.1-.7-.5h-1.8v.5l-.4.4h-.5l-.7.4h-.9v.5l-2.2-.1-.4.5-.5-.1-.4.5h-.8l.1-.5H303l-.8-.9v.7l-.5.7-.3-.1v-1.7H301l1.3-1.3-.4-.5h-1.3l-.4-.4-.1-.8.5-.4-.9-.4v-1.3h-.4l-.8-.8V404l-2-2.7,1.6-.6.5,1.4.6.7.4-.4,1.2.8.9-.8-.3-1.4-2.6-2.5-.5.5v-.9l.4-.3v-.5l.9-1.1v-1.4l.9-1.6-.4-.5a15.92,15.92,0,0,0,1.6-2.4h.5l-.4-2.9-.9-.9.9-1.6-.5-1.3,1.2-.4,1.3,1.4V384l1.7-1.9-.5-.1,1.8-.3v-.4l-.5-.5-.4-.7,2.4-1.7h.5l1.1-2.1h.5v-1.7l-1-2-.2-1.4-1.3.1-.8-.9.9-1.3-.4-.8h.4l.7-.5h2.6l1.2-.5,1.2,1.3.8-.9h.6l1.6,1.3,1.3-.9h1.4l-.1.5,2.5-.5,1.2-1.7,1.9-.4,2.3-.8.7-1.5,2.6.7,2.7-2.5.7-3.1,1.6-1.3,7.1-.1,2.5,1.7,3.1-.1s3.4,1.4,3.5,1.4l2-.4,2.1,1.4,4.2,3.9,1.7,2.7.7-.3,1.5,2,.5,2.1.7.6-.2,1.8.6.2-.1,1.1-.5.4-.1,1.8-.2.5.4.7v1.3l.7.9-1.3.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=Yorks_Humber"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Yorks_Humber",
    d: "M329.8,329.3l-.7.8-.9-.1.7-1.5-2.8-1.8-.7.8-.5.1-1.9-1.1-2.5-4-1.6-.9a9.2,9.2,0,0,1-2.4.6c-1.2.1-3.3.2-3.3.2l-1.4-.9h-1.5l-1.5.6v.8l1.9-.7,1.9,2,2.4-1,1.3.6,1.7-.5,1.6.9,1.3,2.6,1.8,2.1,2.3,1.5-.2.9,1,.8-1.7.4-.4-.5-.8,3-1.3.4-1.2-2.1-.4-2.1.9-1.6-2.5-2.1-1.8,2-1.6-.9-2.2.9,2.2,1.2-2.1.9.5,1.3-2,.5-2.3-.4.5-1.3-3-1.7a21.251,21.251,0,0,1-1.7,2.5l-3-.4-.5-2.1-2.5,3h-2.2a15.2,15.2,0,0,0-1.1,2l-.9.9.4.4-.3.5h-.6l-.2.2-1.7.5-1.2-1.3h-.5l-.4.5-1.2-.5.1-.8h-1.4l-.8,1v-.6l-1.3.5-1.2-.9-.5.5-1.7-2.5.5-.9-2.9-4.5a7.048,7.048,0,0,0-.5-1.8l-2.1-1.2-.7-.8-.6-1.4a9.243,9.243,0,0,0-1.2-1.6v-2.6h-1.8l-.7-.4a2.914,2.914,0,0,0-.5-2.1l1.4-.8s.2-1.8.7-2.1,1.7-.9,1.7-.9l.5-.9-1.2-2v-.9l-1.7-1.1v-.9l-.9-1.2h-1.3l-1.6-3.4-2.5-.3.1-1.4-1.8-2.9,3-3.4,3.8-.8-.4-4.2,2.1-.8.3-2.5,2.9-.4h1.6l1.8-.4,1.8,1.7h.3l6-2.5.3-.5.4.6s2.4.5,2.7,1.5c.4,1,2.3,2.2,2.3,2.2l.4-.7h.9v.4l.5-.8h.4v.5l.4-.5V288l3-.5.7-.8.4-.1.3.5h1.6l1.1.4h.8l.4.4a15.289,15.289,0,0,1,4.5.8l1.6-2.5,2.2,1.2-.3.6,1.1.3,2.7,2.7.8,2.6.6,2,.9,1.9.5,2.3,2,1.9.4,2.1,1.2,1.2,1-.1.6,1,.9-.1.1.9-2.9,2.1.2,4.9.5.6-.4,1.8,4,7.1-.1.9.8.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=North_East"
  }, /*#__PURE__*/React.createElement("path", {
    id: "North_East",
    d: "M311.5,285.5l-.4.4-1.6,2.5a15.288,15.288,0,0,0-4.5-.8l-.4-.4h-.8l-1.1-.4h-1.6l-.3-.5-.4.1-.7.8-3,.5v-1.3l-.4.5v-.5h-.4l-.5.8v-.4h-.9l-.4.7s-2-1.2-2.3-2.2c-.4-1-2.7-1.5-2.7-1.5l-.4-.6-.3.5-6,2.5h-.3l-1.8-1.7-1.8.4h-1.6l.5-.4v-2.2l-.5-.9-2.5-2.7v-1.8l.9-.4-1.4-2.2.9-1.3.8-2.8-1.7-2.1-3.7.5-.8-1.7V265l1.2-2.8.4-2.6,2.1-.3.4-2.1-2.5-.8-1.8-4.2,3.9-4.2.9-.5,1.4-1.5h3.5v-1.3l4.6-2.6-3-7.5,1.2-.5,1.2.5.8-1.3,2.2-1.9,1.8-1.6,1.1-1.5v.1l.9,1.5-.1,1.4,3.6,6.4,2.5,1,1,1,.2,1.9.4.6-.5.7.5,1.8-.5,2.9-.6,1.3,1.1,2.7-.6.1-.1,2.5.3,1.3.8.2v1.5l-1.5,1.2,1,.7.1,1.2.7,1V263l.8.8v1l.7.8.2,1.6-.2,1.2-.8.2.7.7v2.1l.4.5.1,3.1,1.2,2.1,1.7,1.5-.8.4.3.7-.8,2,.9.5.6-1.4,2,1.1.5,1.3,1.5.8.8-.2.9,1.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=Northen_Ireland"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Northern_Ireland",
    d: "M196.7,269.6l-.8-4.2-.1-1.8.4-.3-.9-1.3-1.4-.4-1.1.1-1.7-.9-2.5.7-.4.6-.5-.5-.8-.3.4-1.3h.9l2-1.3,1.1-.2,1.4-.6.5-.9-.1-3.4-1.6-.3-.4-.8v-.6l-.5-.7-2.1-4.2.5-3.5-1.7-1.2v-.5l.9-2.1-1.8-4.2-2.4.6-.5-.6-2.4-1.5-3.5-.5-2.2.9-2.6-.1-.5.5h-3.1l-2.9-.5-1.9,2.7-1,1-2.6.1-1.5-.5h-1v-.7l-1.7.4s-.3-.5-.4-.5a3.329,3.329,0,0,0-.6.3l-1.5,1.4L154,241l-1.3.1-.3,1.6-.1.9-.7,1.6h-.7s-.3.5-.4.5l-1.2.8-1,1-1.1,1.1v-.5h-2.4l-2.7.4-.8-1.3-2.1.8-.3,1.7s.5.3.5.4l.6,1.2,1-.1,2.5.9v1.3l-2.6.4-1.6,1.7-3.8-1.3-1.2,1.3-1.8.8-.3.5-1.7-.4v.4l1,2.1,1,2.9,1.3,1.6.3,1.3,1.2.3.6.6-.5,3.3,1.3.9,2.8,1.1,1.4.8-.1.9,1.5,1.1.5.6.8.3a11.813,11.813,0,0,0,1.3-.6c.3-.1.8-.3.8-.3l-.3.5.9.8.6.2.5.5.5-.4.1-1,.3-.7v1.7l1.2-.8.8-2.2,1.6-.4h.9v-2.1l-.9-1.2,1-1.7.8.4,1.7-1.2.8-.9,1.4-.8,1.8,1.5.7,1.1v.9l.5.5.4.8-.8,1.5-.1,1,.9.4-.1,1.7,1.7,2.4.4-.5.8-.4.8,1.3v1.3l-1.2,2v1.4l.4,1.5.8-.4.4-.5,2.1.5.9-.9,1.2,1.3.8-.3.9-1.8.9,1.3.8-.9.9,1h1.3l3.6,3.8.8-.9h1l1.6-1.3,1.6-3.3.1-1.4,1.3-1,.8-1.4c0,.1-.3,1.2-.3,1.3s3.7,1.7,3.7,1.7l1.1-1.2,2.6-1.7h.5l-.4-2.4-.4-1-2.2.5-.4-.4,1.3-1.2.8-1.8-.6-.6v-.7l.6-1.6-.8-.7-.1-1.3.5-.5.6.1,2,2,.5,2.5V271l-.5.8h-.5l.1,3.4.4.8,1.7-2.5-.1-1.8Zm-19.4-9.7.5,1.7-2.2,2-1.1,1.7-.8-1.1-1.4-.6-1.4.4-1.3-.7.6-2.3,2.3-2.2,1.8-3.3.2-1.6.8.9.4,1.6,1.9-.6,2,.2C179.5,256.2,177.3,259.9,177.3,259.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=South_West"
  }, /*#__PURE__*/React.createElement("g", {
    id: "South_West"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M277.9,390.7l-.3,1.3-2.5,1.3-1.3-1.2V396l-1.3,1.6-1.1,5.3.8,1.8-.8-.4.3,2.7-1.3,2,1.4.4.8,2.5h.5v1.7l.9,1.2-1.3,1.6,1.7,3.8-1.7,3.4h-.9V423l-3.3,1.3-.4.9.9.7-.1,2.2h-.4l.5,1.7v2.5l.9.8-.9,2.5h-1.7l-1.6-1.3h-.6l-1.6-1.7a8.166,8.166,0,0,1-3.3.9,2.431,2.431,0,0,0,1.3,1.5,3.678,3.678,0,0,1,1.7,2.2l-.9.5L262,439a9.14,9.14,0,0,1,1.7,1.2l-.8.8v.4h.4l-.3.5.3,1.2h.6l.7.8h1.8l-.5.4.1.4-2.1.1.4.8-1.2-.3-.6-.5-2-.1-.5.7-1.1.1-.5-1-1-.8h-1l.1.8-1.7.4-.3.7,4.4,1,.2,1.5-.8.8v.8l-.6.6-2-.1-.3-.7-1.3-.1-.9-1-2.6-.3-2.7-.9-.9-.8h-1.3l-.7,1.3.1,1,.4.6.2,1.3-.7.5-.9-.1.9-1.2-.3-1-.7-.1-.5-1.1-2.1-2.4-1.6-1.2-1.2-.8-1.3-1.3-1.2-.3-1.9-.9-1.7.4-3.7-.2-.4.5H224l-.9.3v.7l-.7.6h-1.3l-.2.9-1.4-.4.1-1.2-.6-.6-.1-1.4-.6-.5-.1,1.2.2,2.2.4.2-.8.5-.1.8-.8.8-2.4.2v.5h1.1l.4,2.3a3.654,3.654,0,0,0-1,.7c-.2.3-1.2,1.3-1.2,1.3l.1,1.1,1.1.2.6.9-.8.2-.1,1.1-.9.4-.8-.8.3,1.1-1,.2-.8-.1-1,1.6-.3,2.5-.9-.4-1.2,1-1.2-1.8-.1,1h-.9l-.5-.9-.8-.7.8-2.1-2.2-.3-1.3-.8-1.3.2-1.1-.5.1-.7-1-.1-.3-1.1.2-.7-1.3-.6-.2-1-.5-.7-.8.4-1.4-.5-.4-.6-.5.6,2.6,1.2-.3.5.8.6h.8v.6h-.6v1.1l-1.2-.3V451l-1.4-1.2-3.8-.3-1.3-1.1-.3.6.5.7-.2.9-2.6-.7H185l-1.2.4-.1-1.8-2.1.8-.1,1s-.7.4-.7.5-.4,1.1-.4,1.1l.4.5-.8.8-2-.7-1.7,1.3h-1.5l-.7,1.4-1.1.4.4-2.9L171,452l-.6.4.6.5-.4,1.2.3.7-.7.1-.8,1.6-1.3-.5.1.7,1.4.7.6,1.6-1.7,1.8-1.7-.4-1.3,1.7-1.1-.7L164,460l.3-1.2-.5-2.2-1-1h-1.2l-.5-.7-1.4-.3-.4-.9-1.4-.6-.8.7.3.9-.8,1.2-3.3.7-.6-1-.5-.2v-.8l.7-.5.2-1-.6-.4,1.6-1.3h1.7l1.2-1.2,1.5-.6.9.1.3,1.1,1.3.4s1.5-2.2,1.6-2.2l1.5.5,1.2-1c.1,0,1-.3,1-.3l.9-1.2,1.6-.3,1.5-2.1-.4-.8,1-.4.9.4,1.6-1.8.2-1.7.7-.3v-1.5l.6-.4.2.5,1.5-.6.6.5.1-1.6s1.4.4,1.5.4a7.271,7.271,0,0,0,.9-.8l.6,1.1c.1,0,1.5-1.1,1.5-1.1a12,12,0,0,0,.3-2c.1,0,1.5-.7,1.5-.7h.9l1.4-1.2v-.8l2.8-1.8.9-2.3s-.1-3,0-3a5.582,5.582,0,0,0,.8-.5l.5-2.9a4.349,4.349,0,0,0,.7-.6l1.9.8.9-.1,1.1,1.2,1.4-.1,1.7-1.6s1-.4,1.1-.3l.4.4-.6,1.4.6-.3,1.1-2.1,2.8.1-.7-.6h-2.8l-1-2-.1-1,.8.2.7-2.1,2.4-.1,1.7.6.6-.6,3.4.3.9.6.3-.6,2.8.1.9.6,4,.8.1-.5,2.3.7v.8l1,.3.4,1.2,3.4.5.6.5,1.3-.5s4.5-.1,4.6-.1a4.348,4.348,0,0,0,.7-.4l-.5,2.6.8,1,.5-.7-.3-1.8.8-.5s-.7-1-.6-1.1l.5-.5-.5-1,.4-1.8.5.4.2-1.9,1.2-1-.4-.9,2.7.6.4-1.6,3.3-2.6,1,.1.6,1.1h.8l-.7-1.7,1.9-3.1,5-4.2,3.2-1.5-1.6-2-.1,1,.5.4-1.9.9-1.4,1.4-2.1.9-1.6,2.4-.3-.4v-.4l.1-.4h-.5V402l.4-.4-.4.1v-.5l.4-.4V400h.4l-.5-.4v-.9l.9-.8v-1.7l.9-1.2,1.2-1.3.8.5v-.5H250l1.1-.9,1.1.1a7.772,7.772,0,0,1-.5-2.7l-.4-.7,1.2-2.6.3.8.9.9.4-.4v-.5h1.3a22.978,22.978,0,0,0,.8,2.5h.9l2.3-.8h.7l-.5-1.1.4-1,1.2.5-.8,1.2.4.5.9-.4,1.2.5h.5l.6-.4,2.5-.8,1.7,2,.5-.8-.9-2.1h1l1.5-.8.5-.4.3.8.7.6.5,1.6.5.8h1.4Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M189.1,412l.2,1.9-.6.2v-1.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=Wales"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wales"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M193,393.6l-.3.6h-.6l-.1-.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M252.8,346.5l-.5.5.1.9a7.6,7.6,0,0,0-2.2.9l-1.2-2.1-2.6-1.2V345l-1.3.5v.4l-1.2.4-.8-.1-1,1-.6.2a18.161,18.161,0,0,1-.9,3.9l.9.9.8-.5,1.9,2.7.7.7h-1.3l-.9,2.6-1.3.8.4.4-2.5,1.7.5,1.7-.5.8,3.4-1.2.4.8-.4.9-4.2,1.3-2.1,1.3,3.7,5.1,2.6.4-1.7.8-.3,1.7.8,1.2-1.4-.4-1.2,1.3-2.5,3.8.9.9-.9,1.5v.7l.9,1.1-.1,2.5,3,3.4,2.6.8,2,3.3.9-.4.3.9,1,.4-.9,1.2v1.7l-.9.8v.9l.5.4h-.4v.8l-.4.4v.5l.4-.1-.4.4v.5h.5l-.1.4-2,2.2-2-.1-.7.5-4.5-.2-3.4,1.7-.8-.7-.3.9-1.8.2v.7l.4.1.4,2.1-2.3-.1-.1.6-3-.6-.9-1-.9.8-2.1-1.1-1.8-1.9-.3-1.8-.9-.5-.9.4-.6-1.3-.8-.3.4-1.2-1.4-1.9.5-.7-.9-.7V397l-1,1-1.3.5v-1.2s-.1.8-.6.8-1.5.3-1.6.8c0,.5-.1.6-.1.6l-.9.4-1.7-.1-.2-1-1.3,1.1-2.5-.2-1.2-1,.4-.9-.3-1.1,1.8-.7,4.2-.4.7.4-.2-.8.8-.9-1.1-.3-.1.9-.6.3a6.136,6.136,0,0,1-1.5-.5l-1-.6a1.384,1.384,0,0,1-1.1.2l-2.1-2.3,1-.3-.8-1.4-.4-1.4-1.9.3.4,1.1-3.7-.4-2.8.1-1,.5.6.7a8.254,8.254,0,0,0-1.3,1.7l-1.4-.5v.7h-1.5l-.2-.6h-1.4l-1.5,1.7-1.1-.8-1.3.1-1.3-1.2.5-1.3-1-1.2.5-.5,1,.5.6-.5,2.4,2,.2-.9-.5-.6.8.1v-.5l-.7-1-.6.7-1.1.3-.1-.7-1.3.1-.4-.4.2-1-.5.1-.3.7-1.4.3v1.2l-.9-.1v-1.1l-1.1-1.2.4-.7s.5.5.6.4l.5-.9,2.1-.2.6-.9.1-2.8-1.9-.6-.2-.6h-2.2l-.6.3.1-1.8,1.3-.5h1.7s.5-.9.6-.9l1.2.1.3.4.8-.8,1-.2.3-1.8.7-.6,1.4.8.7-.1-.7.7s1.2.1,1.2,0l.9-.3.5-.8.4.9,1.4.4-.2-1.1,1.3-.5,1-.2.8-1.6,1.2-.1.6.4v-.9l1.1-.3,1.3.6,1-.3v.7l1.8-.3.6-.9,2.2-1.6,1.8.2,3.8-1.7,1.1-1.6,1.6-1.2,1.1-2.8.6-2.2,1.2-1.9,3-1.3h-1.6l-2.1-.8.3-1.2.6-.8-1.4-.5,2.6-2.9,2.5-1.5-2.5.4-.8-2-1.1-1.8,1-1.5v-2.1L220,342l-3,.1-.4.7-2.9-.4-1.8-.6-.1.9-2.3-.5-1,1.2-1.2.4-.5,1.4v.8l-1.3.4-.1-1.2-.8-1.1-1.4,1.1-2.2-.4-.6.6-.7-.9.7-1.1h.6l.3-1.3s4.6-2.8,4.7-2.8l2,.4.8-1.6s1.6-.6,1.7-.6l1.8-1.2,1.4-2.3.1-1.4,1.3-.2,1.4-1.5.3-.6,2.6-1.1.7.5,2.1-.4,2.2-1,1.3-.1a6.72,6.72,0,0,1,1.2.6c0,.1-.1.9-.1.9l.8-.3v-1.1l-.9-.8-.2-1.5.6-.4.3,1.2,1.2-.2.9,1.4-.3.6,6.5.3.4-1,1.4.2,1.4-.6,4,2.7.1,1.3,2.7,2.2.3-.7h.8l2,2.4.1-.4.4.4-.4.4.4.4-.9.9h-1.2l.5,1.2,1.6,1.2-.4.5.8,1.7.4,2,2.5,1.7v1.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M207.6,326.4a15.526,15.526,0,0,1,.4-2.1l.4-.4-.5-.5-.6.7-.3-1-.9-.1-.4,1.7h.9A5.544,5.544,0,0,0,207.6,326.4Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M209.7,320.7H209l.4-.8,2.7.1,1.3-.5,1.7,1,1.7.3-.8,2.1,1.2.4.6.8-.1,1.6,1.1.1.9-.5,1.9.4.7.7-2.2,2.1-1.3.1-.5.8-.7.1-1,.8-2.3,1.7-1.3.5-1.5-.9-.6-1.6h-.7l-.9-.9.5-.4.2-1.8-1.4-1.2v-1.1l1.2-.6-1-1.4Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })))), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=North_West"
  }, /*#__PURE__*/React.createElement("g", {
    id: "North_West"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M273.4,287.9l-2.1.8.4,4.2-3.8.8-3,3.4,1.8,2.9-.1,1.4,2.5.3,1.6,3.4H272l.9,1.2v.9l1.7,1.1v.9l1.2,2-.5.9a15.249,15.249,0,0,0-1.7.9c-.5.2-.7,2.1-.7,2.1l-1.4.8a2.914,2.914,0,0,1,.5,2.1l.7.4h1.8V321a9.243,9.243,0,0,1,1.2,1.6l.6,1.4.7.8-1.8,1.4-.4,1.5-.5.4v.5l-1.2.5h.4v.8h.4l-1.3,1.7.5.8V334l-.4,2.3v2.3a6.035,6.035,0,0,1-.8.8l-.9.3-1,.3-.8-.8-.4,1.3-.8.3-1.5,1.6-1,.6h-1.7l-1,1-1.1,2.3a7.486,7.486,0,0,0-2.6,1.3l-1.3-.9-1.6.4-.8-1.1v-.5l-.6.1-1.2-.5-.8.5-2.5-1.7-.4-2-.8-1.7.4-.5-1.6-1.2-.5-1.2h1.2l.9-.9-.4-.4.4-.4-.4-.4-.1.4-2-2.4h-.8l.1-.3-1-.5.1-1.2.3-.6-1.7-2.7,1.1-1.7,1.5-.3,1-.7.5.7.4,1.1v1.3l1.3,2.6,1.4,1.1,2.1.1,3.2-1.8-.6-.5h-1.7l-.4.9-1.4-.1-3.5-3.4-.2-2.3-.8-.7v-2.1l-.5-.9.6-2.9,2.2-2.2,1.2-1.4.5.8.9-2,.8.9.8-1-1.6-.9-.5.6h-1.4l-.2-.9-.9-.2-.1-1.2.4-.4v-1.9l.7-.4v-1.4l.3-1.5.7-.4.6.5-.3,1.1.5.6-.5.7,1.2.4-.2-2.4,1.4-1.2.9.1,1.1-2.2-1.4-1.5.8-1.6,2.2-.4.4-1,.9-.9-1.5-.8-.6-1.2,2.5-1.5v-1.2l-.6-.6-2,2.5-2.2.8-.8-1.2.2-1.9.5-1.6-.7-.3-.6,1.5-.4,2-3.2,3.2-2.2-1.3,1.8-3.4v-1.8l-1.2.7V292l-.6.3-1.2-.1-1.1-1.3-.2-1.3-.5-2.2,1.3-2.1-1.8-1.6s-.4-1.8-.7-2.6a6.98,6.98,0,0,0-1.2-1.8c-.4-.4-1.2-1-1.2-1.5V277l1-.2.3-1.2.6.4.9-2.4-.2-1.7,1-.3v-.9l3.3-3.2,1.2-3.5,1.7-1.5,3.7.3.5-.5-2.7-.7.5-1.2,4.1,1.8h2.6v-.6l-2.7-.3,1.2-.7,1.4.1-.5-1.1h-.4l.9-2.9,3.3-.4,2.2-1.6,4.1-2.3,1.8,4.2,2.5.8-.4,2.1-2.1.3-.4,2.6-1.2,2.8v1.9l.8,1.7,3.7-.5,1.7,2.1-.8,2.8-.9,1.3,1.4,2.2-.9.4v1.8l2.5,2.7.5.9v2.2l-.5.4-2.9.4C273.8,285.4,273.4,287.9,273.4,287.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M248.4,297.5l-1.1-2.1.4-1.3H247l-.2,1.3,1,2.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M213.7,292.4l.4-1.5,3.8-1.3.5-1.1c.1,0,2.3-.9,2.3-.9a6.552,6.552,0,0,1,0-1.4l2.8-2.7-1.3-.8-.3-1.5,1.3-3.1-4,.8-4.2,4.7-2.2.9-1.4,2.6-.4,1.6-2,2.5,2.5-.6,1.2.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=South_East"
  }, /*#__PURE__*/React.createElement("g", {
    id: "South_East"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M350,430.2l-1.3-.6v1.6l1.1.1.6-.3s.1,2.4.1,3.2c-.1.7-.1,1.9-.6,2.3s-2.1,1.6-2.1,1.6l-.6.8-2.4.2-.6,1-3.1-.1-.3.6-2.3,1,.1.9-1.1,1.2.1,2.3-3.2-.7L332,444l-.9,1.5-1.7,1.6-2,.6-1.2-.3-.7.5-2.4.1-2,.5-1.3.7-.5,1-3,.9-2.6-1.1-.6-.9-3.4-1.6-2.9-1-.8-.2-.6-.4-2.9.2-1,.5h-3l-1-.5-3.7.5-2.4-.2-.1.6-.8-.6-.6.8v1.5l-1.5-.9-1.1-1.5v-1.2l1.2-.4-.2-1.7-.9.4-.1.6-.6.1v-1.4l-1.4.1-1.2-.3-.8.9-.1,1.3-1,.6-.6-.7h-.8l-.4.6-3.3-3.1-.5-1.7h-1a22.508,22.508,0,0,0-.8-2.4l-.7,1.2-1.7-1.4.1.8,3.6,4.1-.7,1.2-4.5.8-1.2-.3v.9l-1.2,1.2-2.1-1.8-.9.1-.1-.4.5-.4h-1.8l-.7-.8h-.6l-.3-1.2.3-.5h-.4v-.4l.8-.8a9.14,9.14,0,0,0-1.7-1.2l.3-1.3.9-.5a3.324,3.324,0,0,0-1.7-2.2,2.708,2.708,0,0,1-1.3-1.5,8.166,8.166,0,0,0,3.3-.9l1.6,1.7h.6l1.6,1.3h1.7l.9-2.5-.9-.8v-2.5l-.5-1.7h.4l.1-2.2-.9-.7.4-.9,3.3-1.3v.5h.9l1.7-3.4-1.7-3.8,1.3-1.6-.9-1.2v-1.7h-.5l-.8-2.5-1.4-.4,1.3-2-.3-2.7.8.4-.8-1.8,1.1-5.3,1.3-1.6v-3.9l1.3,1.2,2.5-1.3.3-1.3.4-1.6a4.2,4.2,0,0,0,.9-1.3h2.9l.8-2.1.5-.4,1.6,3-1.7.3.5.5-.4,1.1v.6h.5l-.1,2.5,2.1.3v.5l2.1-1.7h-.4v-.9l3.4-.8v-.4l2.1.4.8,2.2.8-.4V392l1.3-.8-.9-1.3v-1.4l1.5-.4v-.5h.5l.8-.9,1.6-.4h1.3l.9.9.4,2.9s-.5.1-.5,0a15.92,15.92,0,0,1-1.6,2.4l.4.5-.9,1.6V396l-.9,1.1v.5l-.4.3v.9l.5-.5,2.6,2.5.3,1.4-.9.8-1.2-.8-.4.4-.6-.7-.5-1.4-1.6.6,2,2.7v.6l.8.8h.4v1.3l.9.4-.5.4.1.8.4.4h1.3l.4.5-1.3,1.3h.5V412l.3.1.6,1.2v1.3h.2v1.7l-.5.5L301,418l.8.4h.5l-.1.9.4.4.5-.1.3.5.5-.1-.1.9h.9l.4.4-.1.5h.5l.5.4-.4.4v.5l-.6.5-.1.3-.2.4.5.4.5-.5.1-.6.6-.5v-.5l.8-.1v.5l.5-.1.4.4-.4.5-.1.7.8-.5.6-.1v.6l.4.2V426l.8.5.9-.5.4-.8h.9l.4-.9.8.5v.5l1.2,1.6h1.3l.8-2.1h.4l.5-.3-.1-1.8.5.5v-1.7l.4-.4.4.1v-.5h.8l.1-.6.6-.3.9.8.9-.3,1.4,1.3,2.7.1.3-.9,3.7-.4,2.7,1.6-2.1.2-3.1.9-.5,1.1,1.4-.5,1.3,1.3h1.5l.7-1.4h.9l.5,1.5-.2,1,1.2-.2.9,1.1,1.6.5-.1.4,2.5-.7,1.6-.2,1.1-.6,4.7-.3.2.9,1.9-.3,1.6-.4,1.2.5v2Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M268.1,448.6l1.2-.3,1,.2,3.7,3.7.3-.3.4,1.1.5.1,3.3-.7.4-1.6-.3-.6V450h2.3l-.8-2.2.1-.9-2.6.3-.5-.5.2-.9-.7-.7-.4.8v1.4l-.6.5-.2-.4.3-1V445h-.5l-.7,1.1-.9.3-.5,1-1.4-.6-1.7.2-.5-.4Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M285.9,445.1l-1.3.1-1.1-.5,1.6-1.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M336.5,426.4l-2-1.3-.7-1.5.5-1,1.3.3.1.9,3.6,2.4Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=Scotland"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scotland"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M305.6,158.6l.1,1-.9,1.3-2,1.7-.9.3-.5,1.3-3.8,5-.7,4.5-1.4,2.3a10.144,10.144,0,0,0-1.3.9c0,.1-2.1,5.7-2.1,5.7l-1.4,1.7-4.2,2.8a13.431,13.431,0,0,0-1.1,3.1l-1.4.5-.2,2.3-1.7,1.5-.3.5-4.7,3.2-1.3-.9-2.1.5-.9-.6-1.2.8-2.2-.6a25,25,0,0,0-2.4,1.2c-.8.4-3.3,2.1-3.3,2.1l-.1.8,1.7-.1a22.192,22.192,0,0,1,2.4-1.4,15.438,15.438,0,0,1,4.2-.9l.5-.7,2.5,1,1.1,4.7,1.3.6,1.2,1.3.2,1.4-1.6,1.4a8.069,8.069,0,0,0-2.9.9h-2.6l-1.9-1.4-1.5,1-1.5,1.5h-1l-1.1,1.1-.4,1.7-1.4.3-1.1-.8-.9.9-1.9-.1-.3.8-1.4-.2-5.7-3.7h-1.1l1.3,2.9,3.7.8,1.9,1.1,1.7.1,2.7,1.2,2-.1.6,1,1.3,1,2.2.1,4.7-4,3.2.5,3.2,2.6,3.6,3.7.6.1.7,1.2h1.5l.8-.2,1.4,1,.1,1.2,1,.9v1.4l.5.4v.9l-1.1,1.5-1.8,1.6-2.2,1.9-.8,1.3-1.2-.5-1.2.5,3,7.5-4.6,2.6v1.3h-3.5l-1.4,1.5-.9.5-3.9,4.2-4.1,2.3-2.2,1.6-3.3.4-.9,2.9-6-.7-6.9-1.4-.8,3.9L243,261l-2.5,1.1-.9-1.7-.6,2.8-.9.1-.7.7-2.2,1.1-2.1-1.1-1.6.1-1.3-1a2.556,2.556,0,0,0-.7-1.2c-.5-.4-2.1-2.1-2.1-2.1l-2.8-1.7,1.5,3.5.4.3-1.3,2v2.3l-1.2.7-1-.5-6.5-7.2-1-2.4-3.3,1.3-.4,3.6.2,4.1h-1.1l-1-2.4.6-1.4-1-2.8-1.6-2.3-1.3-3.7,1-3.3,1.7-.5.9.3-.2,2.9.4,1.3.6-.4.5-2.3-.5-2v-.8l4.1-5.5,2.4-1.4,1-2.6,2.7-4.6,3.8-2.5-.4-2.9-.5-.4.9-.8-2.1-2.9-1.3-.4-1.3-3,1.5-2.1.4-2.2L222,213h.8l1.7-2.5,2.8,1.9,4.7,1.7,1.3,1.4h.4l-1.1-2.2-1.3-.2-3.9-2.1-.4-1.5-1.2-1.2-.5-2.2h-.6l.1,2,.9,1.3-1.7.6-.5-1.3.4-1.4-.6-.7-.4,1.1-.2,1.9-.9.3.3,1-1.2,1.3-1,2.2-1.9-.7.5-1.2-.4-3-.7.1.2,2.5-.4.4-.7-1.1-1-1-.2-1-.6.1-.2,1.7-.5.5-.3,2.7-1.1-.3-.8-.7-.1-3.9.4-2,5.3-5.4,1.9-.4,1.7-2,2.4-1.3.2-.7-2.3.8-.2-.6-3.7,3-.7,1-1,.2-3.3,3.8-1.3,1-.9-.8-.8.2.1,5.5,1.7,3.6-.6,1.9h-1.4l-.9,1-2.5,5.3-.1,1.3-.8.3-.6,2-2.6,3.1.6,2.5-2,2.2-2.9-.1-2.1-1.3.7-3.3,1.6-.9h1.2l.6-5.7,1.8-2.2.5-2.6s2.7-2.2,2.7-2.3l2.5-1.2,1.5-2-.4-.6-1.8,1.8-2.2,1.3-.5-.8.5-.8-1.1-.8.4-1.5,1.6-1.7.8-1.2-.5-.4-1.1,1.2h-.9v-.7l2.2-2,.5-1.4.9-.4v-.8l-1.1.5-1.3,2-1.2,1-.4-1,1.3-1.5.9-.8,2.4-2.4.9-.3.2-1.2,1.1-1.3-.5-.4-1.3,1-.6.9-.6-.1.8-1.5,2.3-1.9-.2-.8,1.6-.8-.3-.5-1,.3-.7-.4-1.2.5-.4,1-.2,1.2-.6-.5v-1.7l1.1-1.1v-1.3l1-.8.4,1.1.8-1.5,1-.3.1-1.3-.4-.9,1.4-.9.3.3,1.4-1,1.3.2-.7-1.6-.8.1v-.7l2.5-1-.6-.8.7-1.4,2.6-2.2-.4-.5.7-.4,3-.2-.3-1.2-1,.3-.1-.7,2.5-2.4,1-1.4-.6-.3-1.3,1.5-1,.3-.6,1.1-2.2,1.9-2.4,1.6-.6-.5-1.1,1.3h-.9l-.6,1.4-1.5,1.5L210,184l-.5.7-1.2-.2-.2-1-1.9-1.2-1.2-.1-1.7-1.7-.2-1.4-.7-1.4v-.9h3.9l1-.3h.5l.5-.6.5.1,1.2.8,1.5.5h1.7l-.8-.5h-1.8l-.7-1.2h-.6l-.2-.4h-1v.3l-.5.1-.3.4h-.5s-.3.5-.4.5l-.4-.5h-1.7l-.6-.6-2-.3-.3-.9-1.7.6-1.2-.6-.3-1.9,1.4-1.1,4.8.8v-.8l2.2,2,.4-.3-.5-1.1.4-1.3,1.3-.6,2.5-.4-1-.9,1.5-.8-.1-.6-3.7.3a10.909,10.909,0,0,1-1.1-.6l.5-.6h1.4l-.1-.9,1.1-1.4.3-1.5h2.6l1.6,2.2,2.5-.1V164h-1.7l-.9-.6-.2-1.4-1.3-.2-.8-1.1,1.9-2.2,3.4,1.4h1l-.4-1.6a16.966,16.966,0,0,0-1.4-1c-.1,0-1.2-.3-1.2-.3l.1-1.2,1.5-.8v-1.4l2.7-.7,1.5,2.1h.9l-.7-1.4-1.3-1.4h-1.7l-.9-.7h-2.1v-.8l2.2-1.6,2-.1-.4-1v-2l-1.9,1.9-1.3.4h-1.5l-.5-1.7.5-2.4-.6-1.5,1.5-4,1.6.5.2,1,1.2.1.3,1.8,1.2-.9,1.4.4.9-.6-1.2-.5-1.5-.1-.7-.6-.9-1.5.3-.3-.5-1.6-1,.1v-.7l2.4-1.8.5.5.7-.5-.3-1.4-1.3.1-1-1.6.8-.9-.2-1.9.4-1.1h2.6l.3,2.8.8,1.6,1.1-.7.4-1.9-1.2-.5-.1-.8-.3-.8.8-.5.4-.7h.8l.9,1-.1,1.6,1.3.5,1.3-1.3,2,1.1.8,1.4.9.3-.1-.7-1.1-1.3-.1-.8a11.111,11.111,0,0,1-1.6-.7l.2-.9.9.1,1.6,1.2.8.1,1.5,1.5h.7l-.6-1.1-1-.9.8-.6-1.4-1.4-1-.4.1-1.4-1.2-1.5-.9-.2-.4-2.1.8-.7,1.3,1.5,1.2.6.7-1.6-.1-1.1,1-.5-1.1-.9-.4-2.5-.6-.5.6-1.3,1,.9.1.7,2.7-.2,1.3.4.8-.6,2,1.5,1-.1s-2.1-1.8-3-2.4l-.8-2.4.8-1.7,1.1-1.3.7.9.4-.5-.1-1.3.9-.1.6.6.3-.9-2.3-1.7.6-1.4,2.3-2.1.9-1.8.8.1.6.7h1.3l1.1,1.8-.7,1.3v1.2h.8l.6-3.2.8-.3.2,1.8a5.973,5.973,0,0,1,1.1.6V104l-2.4,2.2.2.7,1.9-1,2.6-3.3,1.8.4,1.1,1.4-.6,2.4-1.4,1.1v.6l2-1.5,1.4-1.9h2.1l.7,1.5.6-1.3h1.2l.4-1.1,1.4.4.2.7,1-.4V104l.9-.2.2.9,4.8,1.6,3.1-1.4,1.2-.6,1.4.2-.4.6,3.6,1.4.8-1.4-.7-.5-.4-1.3,4.7.3.1.8,3.2,1.5s-.8,2.7-1.5,3.2-1.2.8-1.2.8l.5,2.3.6.5-.1,1.6-1.2.8-.4,1.7a2.97,2.97,0,0,0-1.1.6c-.3.4-1.1,1.2-1.1,1.2l-1.7.8a5.7,5.7,0,0,0-1.3-.1l-.1.8-1.5-.4-3.3,3.4-2.5,1.8h-1.4l-1.1,1.4-5.7,3.5-4.4.7,1.3,2.3-2.8,2.1-1.5-1.1-2.4-.4-1.9-2.9-.6.2,1.8,3.2,2.9.7,2.8,2,2.4-.8.4,1.4,1.6-1.3.9.3-1.8,2.9-2.7,2.8h-1.1l-.5-.7.8-1.4-2.5.8-1.3.9-.9-.8-2.8,1.4-1.9,1.3-.9,2,4.8-3.4,3.6.1,1.3.6-1,1L254,145v1.1l-1.5.1-.5.8-1.6-.3.3,1.2-.8.8-.9-.7-2.3.1,2.9,1.1,2.1.3L255,147l-.1-1.2,1.4-.6.7.7,4.9-.5,2-1.4,1.9,1.8,2.6-2.5,1.9-.1,2-.4,4.6,3,2.1.8.7-.6,1.1.4.8-1.2,1.3.1.6,1.2.9-.4s1.9.7,2,.8l.2.4.8-.4,2,.7.5.9,4.4.4,1.1-.6,1.3,1,1.7-.1,1-.9,2.7.8,3.3,5.4.6,3.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M186.6,232.2l-.9,2.1-1.7-2.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M229.7,123.4l.3.6-.7.2-.2-.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M228.7,122.8v-.9a5.652,5.652,0,0,0-1.3,0l.2.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M234.2,112.9l-.3-.4-.7-.4.3-.2.1-.3.9.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M219.5,220.8l-.7.2.1-.9h.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M220.2,219.6h-.6l-.1-.7.6-1,.9.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M213.4,225.5l.4-4.1-1.2-1.1v-.6l-1.5-.6-.5.5-1.7.7-.1.9-.8.7v2.5l.5.8-.4.9v1.5l.4.2v.8l.8,1.9,1.6.8h2.9l-.2-1.3.8-.9-.2-1.4.6-.8-.3-.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M214.6,216l.6,1.2-.7-.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M215.9,214l-.3,2.9.4.4.7.1-.2,1,.6,1.1.8.6.3-.8-.7-.4,1-2.4-.1-1.8-.8.1-.4-.8.3-.8-1.1-.9-.5-1-.7-.4-.9.7.1.7.2.2.4,1.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M199.5,221l-.1-.6-.5.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M199.2,220l1.2-.6.5-1-.5-.4.9-1.3-.8-.2-.4.8-.5.6v.9l-.4.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M187.1,211l-1.2,1-.2.9-1,1.1-1.8,1H182l-.1-.7,1-1.7.2-.7.7-.5.1-.6-.3-.6,1.1-2.4,1.9.1,1.2-.5-.1,2.4,3.8-3.7,1.7.6-.5.7.4,2.5-.4.3-.1,2.2.5,2.4.3.5-.4.6.4.5.1.7-1.1.7-.6-.6-.1.9-1.2.7-1.5.1v-.5l-1,.1-.5,1.1-1.1.7-.6-.5h-.6v-.6l1.1-1.3-.1-.9h.6l.4-2.4a5.638,5.638,0,0,1-1.2-.4,4.349,4.349,0,0,1,.6-.7l1.5-.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M196.8,211.7l-1.4,1.3v-.6l-1.3-.4-.9-.9-.1-1,.4-.5-.2-.8.3-.4.1-.8,1.1-1,2.3-.8.6.4.5-.3h.9l.2-.6-.6-.3-1,.6-1.3-1,1.5-1.4.3-.7.8.1.6-.9,3.1-1.1,1-1.2.3.3.5-.5.8.1.1,1.1-.7.4-.5.9-.8.2-.1.8-1.2,1.7-.6.1-.7.9v.6h-.7l-1.2,3s-.5-.3-.5-.2-.1.7-.1.7l-.6-.1-1.1,1.4Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M192.1,201.9l-.9,1,.3-1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M192.9,201.6l-.8-.1-1.1-.3.1-.8,3.5-2.8v1.1l-1.7,1.8Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M205.2,197.5l.7-.5.5.2-.1,1h-.5l-.7.4-.7-.5.2-.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M205.1,195h-1l.4-.6h.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M212.6,185.7l1.8-1.9.7-.2v-.7l-.8.2-.2.5-2.2,1.6-.8.1-.5,1,.5.4.8-1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M190.2,188.9l-.4-.8-.5.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M190.4,190.2l.3-.6h.6l.1-1.1s.3-.7.4-.7a5.284,5.284,0,0,0,1.2.1l.2.9,1.1.7v-.9l2.5.6,1.1.1.4-.5,1.4-.1,1-.9-.1-.6-1,.6-.7-.2-1.8.6-1.5-.8,3.4-2.2,1.4-1,1-.1.1-.8-1.4-.3-.5.6-1.7-.8v-1.1l-.7-.1-.4-.9-2.6-.3.1-.9,1.2-.8a4.331,4.331,0,0,0,.1-.5l-.6-.2-.1-1,1,.4.6-.5.4,1,.7-.1v-1.2l.4-.7,2.1.1,1.1,1.3-.6.4.4.6h.6l.8,2,.1,2.2,5.9,3.8.4,1.9-.6.2v.9L207,189l.3-.9-.6-.6v1.1l-.6-.1-.4.9.8.1.5.6-3.6,1.3-.7-.4.2-1.8-1.7,1.4-1.1-.2-1.5.9h-.7l.1-.7-1.5.3-.6.6-1-1-.5.4-.3-.4a10.474,10.474,0,0,0-.8,1.1l-1.5-.5.4-.4-.4-.5-.6.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M196.1,183.1l.2.7,1.5-.2-2.2-1.7-1.3.5.8.2.2.7C195.2,183.2,196.1,183.1,196.1,183.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M180.6,179.6l-.4,1.5h-.9l.2-.7-1.2-.2.3-2.5.4-.3h2.3l3.6.7-.2.6-.9-.4-1.1,1.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M187.4,176.4l.9.4.8-.4,1.8-.6,1.5-3.2h-.9l-2.4,1.6-1-.1-.2,1-1,.5-1,.2-.2.6.5.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M199.6,167.7l-.2.5-.6.1-.4-.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M201.8,166.8l-1.4-1.6,1.3-.9.6,1.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M192.9,157.2l1.9.2.5-.2-.6-.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M196.7,161l-.7-.3-.2-1.2,1.6-.7.4-.6,1.3-.3,1.3,1.9-.5.3.5.9-.4,1.2-1,.5-.3.4-1-.1-.8-.8Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M196.6,143l.1,1.2-.2,1.2h-.8l-2.8-2.6.1-.9-.9-.7-.1-.7.7-.6.3-.9.7.6s1-2.5,1-2.4a16.052,16.052,0,0,1,.8,3l1.4.4-.6-1,.7-1.5.5-.3v-1l-1.3-.4.1-.6.7-.3-.2-1,.5-.8.6.4,1,1.8v1.6l.9.6-.1.9h.6l.5-.7.1.9.8-.7,1,2.2.4-.3-.1-.7-.5-.7.2-.6-.6-.7-.1-.9.9-.9h-.7l.7-1.2-.5-.3.4-1.8,1.4-.5.1-1.1.4.3.7-.2,1.1,1.3,1.7,4.1v2.4l-1,1.8-.8,3.2-.7-.2-.4.6.6.1.8,1.5-.3,1.3.2,1.1-.9.2,1.6.9-.2.9.8-.1.7.5.1-.7-.4-.7.9-.4.7.4.4,1.3-.7.4H209l1.9,1.6,4.1-.4,1.5.9-2.4,2.6-1.8-.2.3.9-1.3,1.8-.8.1-.1.9-1.9.9-.8.9-1.8-.4.1-1.6.8-.4-.3-.8.6-.1v-.9l.6-.4.8.1.1-.6.8-.1V155l-1.4-.1v-1.6l-.6-.2-1.7,2.9h-.8l-.3-.6.6-.9s-.5-.7-.4-.7l.2-.6-.6-.5-.8.8-.5-.4-1.3.5-1.8.1.8-1.7-1,.1-.5-1,.5-1-.7.1-.1-.8-1-.4-.1-1.7,1.5-1.4,1.4,1.3.3-.4-1.1-1-.2-.7h-1l-.7-.7.5-.2.3-.9-.5-.3s-.9.8-.9.7-.1-1.1-.1-1.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M201.8,155.5l.6-.4.4-.1-.2-1-.8.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M208.4,148l1.1-4.8.6-.1.5-1.6-.7.2-.4,1-.6-.2-.6,1.1-.5.1.1,1.9-.4.7.2,1.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M211.5,140.4v-1.1l.7-.4v-.7l-.9.5-.5.7.2,1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M171.3,157.5l-1.4-1.1.5,2.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M172.1,156.9l-1.7-.8a15.234,15.234,0,0,1,4.3-2.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M174.8,132l-.4.9-1-1.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M186.4,127l.7-1.8-2,1.1.6.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M178.5,151.8l-2.9-1.1.1-2.9,1.3-4.7.2-4.7,2.1-.3-.7-2.5,2-.9-1.4-3.6-2.3-1.8,1.8-1.9,4.4.6,2.4-.7,2.6,2.8-.9.9-1.6-1.2-.8.1,1.8,2.3-2.3,3.9-2.4-.6.5,1,.2,2.3h-1.8l.8,3-3.2,4.4,1,2.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M191.7,120.2l.6-1.3-.5-.3-1.8.8Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M188.6,121.5l2.1,5,3.8-2,.7-.8,2.1.2-.3-3.3,2.1,1.1-.4-3.7.4-1.5s.6,3.2.7,3.9l4.2-.1a30.406,30.406,0,0,1,3.7-3.1l-.1-3.3-2.2.2-2.6-.7,1.1-.4,3-.2,1.6-.5-.1-3,1.3.8.9-.4,1.9,1,2.2-2.8-2.9,1.3h-1.7v-1.1l1.3-1,2.3-3.3.5-2.4,1.1-1.1V99.1L214.2,97l-.6.9-4.8,2.1-2.9,2s-5.1,1.1-6.5,2.1l1.2,3.7-.8.2-1.7-3.7.2,3.1-1.8.3-.3-.8.9-.6-2.7-1.3-1.9,3.7-1.1,1.1.9,3.3,2.5-.2.3.6-4.2,1.1v1.5L193,118l2.6,1.3v.9l-2.9-.2-2.8,1.9-.9-.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M282.6,98.9l-1.2-1.2-.8-1.5L279.3,94l1.2-1.7.9-.3a14.308,14.308,0,0,0,1.1,1.5c.1,0,1.7,1.6,1.7,1.6l.3,2.4.4.6-1.4.8V98Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M286.1,98l.7-1.3-1.4.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M290.6,97.5l-1.2-.8,1-.7Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M289.9,97.5l-2,.1.7,2.2-.9,1.6,1,.7.9-1.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M294.2,93.9l1.4-1.3-.4,2.4h-2.1l-.6,1.4L290.7,95l-1.2-2.6-3.4.7h-1.5a18.7,18.7,0,0,1-.8-2.5l-.8.9-.8-.3-.3-2.7,1.3-5.4,2.6.1.1,1.5,3.5.8.8,2.2-2,.8a10.1,10.1,0,0,0-.7,1.5l2.4.3.1.9,1.1-.8-.1,1.4.6.7,2.3-1.4-.4,2.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M293.2,90.5a5.6,5.6,0,0,1,1-1.8l-.1-1.1-2.6,1.6S292.6,90.6,293.2,90.5Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M299,88.9l.7-1.4,1.1-.4L299,85.2l-1.8,3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M290.6,84.9s-2.2-1.4-2.2-1.5l.7-1.8,2.5,2.2Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M293,80.5v-2l-2.2.1.2-1.8,2.3-1.2.5.8.1,4.1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M297.8,83.4l2.8-1.9h1.2l1.5-1.8-2.1.2-1-.3-1.6,1.8Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M337,78.1l.9-4.1-.2-1.9h1.9l-.2-2.9,1.9-3.4-1-5.1.3-1.2.9,2.1,1.7-.9,2-6.4h-3.9l3.1-2,2.1-2.6-.7-3.9,1.8-.9.4-3.5-2.1-.3-.3,3-2.3,1.7L342,44.4l-3.2.8L337,48l-1.6-1.5-1.8,3.4,3.5,1.2.8,3-1.8.2,1,1.2,2.7.4-1.7,1.3-2.3-.4-1.1,1.1.1-1.6-1.9,1.2-2.2-.7.2,2.6,3.9,1.7-1.4,1.4,1.1,1.8,2.1-2.7.9,1.9,1.3-1.3-.2,4.5L335,75.2l.6.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M342.6,66.8l1.8-1.4-.7-1.1H342Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M346.1,57.8l2.1-1.9-2.5,1Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M351.6,48.5l1-2.3-3-.5-.2,2Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M350.4,43.7l3.3-5.3-2.2-1-2.3,5.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M327.8,84.9c-.1,0-1.4.8-1.4.8l-.4-.1v-1a5.718,5.718,0,0,1,.8-.7A9.427,9.427,0,0,1,327.8,84.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M324.6,57.8l.3,1.4-.5.7-1.1-.3-.2-1.3Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M353.2,54.5l-1.7-.1.1-.9h1.6Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M334.1,53.8s-2.2.6-2.2.4a9.633,9.633,0,0,1,0-1.7c.1,0,1.6.2,1.7.2A11.731,11.731,0,0,0,334.1,53.8Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }))))), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=West_Midlands"
  }, /*#__PURE__*/React.createElement("path", {
    id: "West_Midlands",
    d: "M289,377.3v.4h-.5l-.3.4h-1.7v.5l1.3.8-.5,2.1-.9.4-1.1,2.5H284l-.4.9-.5.4-.8,2.1h-2.9a2.881,2.881,0,0,1-.9,1.3l-.4,1.6-2.8-.8h-1.4l-.5-.8-.5-1.6-.7-.6-.3-.8-.5.4-1.5.8h-1l.9,2.1-.5.8-1.7-2-2.5.8-.6.4H264l-1.2-.5-.9.4-.4-.5.8-1.2-1.2-.5-.4,1,.5,1.1h-.7l-2.3.8h-.9c-.2-.4-.8-2.5-.8-2.5h-1.3v.5l-.4.4-.9-.9-.3-.8-1.2,2.6.4.7a7.772,7.772,0,0,0,.5,2.7l-1.1-.1-1.1.9h-1.7v.5l-.8-.5-1.2,1.3-1-.4-.3-.9-.9.4-2-3.3-2.6-.8-3-3.4.1-2.5-.9-1.1v-.7l.9-1.5-.9-.9,2.5-3.8,1.2-1.3,1.4.4-.8-1.2.3-1.7,1.7-.8-2.6-.4-3.7-5.1,2.1-1.3,4.2-1.3.4-.9-.4-.8-3.4,1.2.5-.8-.5-1.7,2.5-1.7-.4-.4,1.3-.8.9-2.6h1.3l-.7-.7-1.9-2.7-.8.5-.9-.9a18.161,18.161,0,0,0,.9-3.9l.6-.2,1-1,.8.1,1.2-.4v-.4l1.3-.5v.5l2.6,1.2,1.2,2.1a6.651,6.651,0,0,1,2.2-.9l-.1-.9.5-.5V345l.8-.5,1.2.5.6-.1v.5l.8,1.1,1.6-.4,1.3.9a7.486,7.486,0,0,1,2.6-1.3l1.1-2.3,1-1h1.7l1-.6,1.5-1.6.8-.3.4-1.3.8.8,1.2-.2.9-.3.8-.8,2.5.9,1.3,1.3.5,1.5-.1,4,.4.4v1.3a7.565,7.565,0,0,1-1.7,1.2l-.4,1.3-.9.3v1.4l.4.7,2.1.9v.4l1.2.5h1l1.6,1.6-.9.4.5.9-.5.5v.4l-.4-.4h-.6l-.7.4-1.2,1.7,1.1.3,1.8,1.3s.2,1.3.9,1.7l-.8,1.6.8,2.1,1,1,.5.2a20.576,20.576,0,0,0,1.5,1.5,8.331,8.331,0,0,1,2.2,2,7.845,7.845,0,0,0,1.4,2,10.5,10.5,0,0,0,.2,1.3,8.143,8.143,0,0,1,.2.9Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("a", {
    href: "/PaceAdministrationTeam/Resourcing/RegionsMap?region=East_Midlands"
  }, /*#__PURE__*/React.createElement("path", {
    id: "East_Midlands",
    d: "M324.1,357.2s-1.6-1.1-1.7-1.1l.7,1.9a25.314,25.314,0,0,0-2.3,1.2l.1.6,1.3-.2,3.1.6,1.6,1.8.1.9,1.1.8-.7,1.5-2.3.8-1.9.4-1.2,1.7-2.5.5.1-.5h-1.4l-1.2.9-1.6-1.3h-.6l-.8.9-1.2-1.3-1.2.5H309l-.7.5h-.4l.4.8-.9,1.3.8.9,1.3-.1.2,1.4,1,2v1.7h-.5l-1.1,2.1h-.5l-2.4,1.7.4.7.5.5v.4l-1.8.3.5.1-1.7,1.9v.6l-1.3-1.4-1.2.4.5,1.3-.9,1.6h-1.3l-1.6.4-.8.9H297v.5l-1.5.4v1.4l.9,1.3-1.3.8v.4l-.8.4-.8-2.2-2.1-.4v.4l-3.4.8v.9h.4l-2.1,1.7v-.5l-2.1-.3.1-2.5h-.5v-.6l.4-1.1-.5-.5,1.7-.3-1.6-3,.4-.9h1.3l1.1-2.5.9-.4.5-2.1-1.3-.8v-.5h1.7l.3-.4h.5v-.4l-.9-1.3a2.042,2.042,0,0,0-.2-.9,10.5,10.5,0,0,1-.2-1.3,7.183,7.183,0,0,1-1.4-2,10.482,10.482,0,0,0-2.2-2,10.4,10.4,0,0,1-1.5-1.5l-.5-.2-1-1-.8-2.1.8-1.6a3.447,3.447,0,0,1-.9-1.7l-1.8-1.3-1.1-.3,1.2-1.7.7-.4h.6l.4.4v-.4l.5-.5-.5-.9.9-.4-1.6-1.6h-1l-1.2-.5v-.4l-2.1-.9-.4-.7v-1.4l.9-.3.4-1.3A7.565,7.565,0,0,0,278,348v-1.3l-.4-.4.1-4-.5-1.5-1.3-1.3-2.5-.9v-2.3l.4-2.3v-1.6l-.5-.8,1.3-1.7h-.4v-.8h-.4l1.2-.5v-.5l.5-.4.4-1.5,1.8-1.4,2.1,1.2a7.048,7.048,0,0,1,.5,1.8l2.9,4.5-.5.9,1.7,2.5.5-.5,1.2.9,1.3-.5v.6l.8-1h1.4l-.1.8,1.2.5.4-.5h.5l1.2,1.3,1.7-.5.3-.4h.6l.3-.5-.4-.4.9-.9s.8-1.5,1.1-2h2.2l2.5-3,.5,2.1,3,.4a21.251,21.251,0,0,0,1.7-2.5l3,1.7-.5,1.3,2.3.4,2-.5-.5-1.3,2.1-.9-2.2-1.2,2.2-.9,1.6.9,1.8-2,2.5,2.1-.9,1.6.4,2.1,1.2,2.1,1.3-.4.8-3,.4.5,1.7-.4.3.3,1.7,1.9,1.6,3.2,1.5,1.8,1.7,7.5-.9,3.2.1,1.6-5.5,2.8Z",
    fill: "#021332",
    stroke: "#fff",
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-64 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 794.67, 577.47)",
    filter: "url(#Path_79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-13",
    "data-name": "Path 79",
    d: "M0,0H16V5L-1.5,6.911Z",
    transform: "translate(201.33 374.53)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "London-2",
    "data-name": "London",
    transform: "translate(1004 956)",
    fill: "#162637",
    fontSize: 3,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.344,
    y: 0
  }, "London"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-42 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 772.67, 609.47)",
    filter: "url(#Path_79-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-14",
    "data-name": "Path 79",
    d: "M.352,0H20.12V6.164L-1.5,8.521Z",
    transform: "translate(223.33 342.53)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Anglia-2",
    "data-name": "Anglia",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1005.728, 957.476)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.584,
    y: 0
  }, "Anglia"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-70 -65)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 800.67, 647.47)",
    filter: "url(#Path_79-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-15",
    "data-name": "Path 79",
    d: "M1.625,0H35V6.164L-1.5,8.521Z",
    transform: "translate(195.33 304.53)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "East_Midlands-2",
    "data-name": "East Midlands",
    transform: "translate(1014.07 957.555) rotate(-2)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.305,
    y: 0
  }, "East Midlands"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-78 -107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 808.67, 689.47)",
    filter: "url(#Path_79-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-16",
    "data-name": "Path 79",
    d: "M1.949,0H38.786V6.164L-1.5,8.521Z",
    transform: "translate(187.33 262.53)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Yorks_Humber-2",
    "data-name": "Yorks/Humber",
    transform: "translate(1016.07 957.59) rotate(-2)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.037,
    y: 0
  }, "Yorks/Humber"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-88 -148.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 818.67, 730.97)",
    filter: "url(#Path_79-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-17",
    "data-name": "Path 79",
    d: "M1.417,0H32.563V6.164L-1.5,8.521Z",
    transform: "translate(177.33 221.03)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "North_East-2",
    "data-name": "North East",
    transform: "translate(1012.07 957.727) rotate(-2)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.487,
    y: 0
  }, "North East"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-133 -225.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 863.67, 807.97)",
    filter: "url(#Path_79-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-18",
    "data-name": "Path 79",
    d: "M1.417,0H32.563V6.164L-1.5,8.521Z",
    transform: "translate(132.33 144.03)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Scotland-2",
    "data-name": "Scotland",
    transform: "translate(1012.07 957.727) rotate(-2)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.219,
    y: 0
  }, "Scotland"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(808.504 912.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -77.83, -330.05)",
    filter: "url(#Path_79-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-19",
    "data-name": "Path 79",
    d: "M19.882,0H-1.5V6.164L21.881,8.521Z",
    transform: "translate(90.01 330.05)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Wales-2",
    "data-name": "Wales",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 21.89, 5.476)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.92,
    y: 0
  }, "Wales"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(819.504 969.979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -88.83, -387.51)",
    filter: "url(#Path_79-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-20",
    "data-name": "Path 79",
    d: "M29.65,0H-1.5V6.164L32.563,8.521Z",
    transform: "translate(90.33 387.51)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "South_West-2",
    "data-name": "South West",
    transform: "translate(16.925 5.674) rotate(3)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.48,
    y: 0
  }, "South West"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-70 22.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 800.67, 560.23)",
    filter: "url(#Path_79-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-21",
    "data-name": "Path 79",
    d: "M1.417,0H32.563V6.164L-1.5,8.521Z",
    transform: "translate(195.33 391.77)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "South_East-2",
    "data-name": "South East",
    transform: "translate(1012.07 957.727) rotate(-2)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.358,
    y: 0
  }, "South East"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(847.496 901.979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -116.82, -319.51)",
    filter: "url(#Path_79-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-22",
    "data-name": "Path 79",
    d: "M33.637,0H-1.5V6.164L36.923,8.521Z",
    transform: "translate(114.93 319.51)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "West_Midlands-2",
    "data-name": "West Midlands",
    transform: "translate(14.934 5.83) rotate(3)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.427,
    y: 0
  }, "West Midlands"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(846.47 816.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -115.8, -233.77)",
    filter: "url(#Path_79-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-23",
    "data-name": "Path 79",
    d: "M32.746,0H-1.5V6.164L35.948,8.521Z",
    transform: "translate(113.91 233.77)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "North_West-2",
    "data-name": "North West",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 14.89, 5.828)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.608,
    y: 0
  }, "North West"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(746.743 784.479)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16.07, -202.01)",
    filter: "url(#Path_79-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79-24",
    "data-name": "Path 79",
    d: "M39.524,0H-1.5V6.164L43.36,8.521Z",
    transform: "translate(10.5 202.01)",
    fill: "#94b0da"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Northern_Ireland-2",
    "data-name": "Northern Ireland",
    transform: "matrix(0.999, 0.052, -0.052, 0.999, 13.968, 6.04)",
    fill: "#162637",
    fontSize: 5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.851,
    y: 0
  }, "Northern Ireland"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRegions);
export default __webpack_public_path__ + "static/media/map-regions.bb964af0f8e184c45b9a592f193b3b3e.svg";
export { ForwardRef as ReactComponent };